import React from 'react';
import { Link } from 'react-router-dom';
import { Home, ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';

export default function NotFound() {
  return (
    <div className="min-h-[60vh] flex items-center justify-center bg-background py-20">
      <div className="container max-w-2xl mx-auto px-4 md:px-8 text-center">
        <div className="font-serif text-[120px] md:text-[180px] font-bold leading-none text-brand">404</div>
        <h1 className="font-serif text-3xl md:text-4xl font-bold text-primary mt-4">Page Not Found</h1>
        <p className="mt-4 text-muted-foreground text-base">Looks like the page you're looking for has taken a detour. Let’s get you back on track.</p>
        <div className="mt-8 flex flex-wrap gap-3 justify-center">
          <Link to="/">
            <Button className="bg-brand hover:bg-brand-dark text-white rounded-full h-11 px-6 font-semibold">
              <Home className="w-4 h-4 mr-2" /> Back to Home
            </Button>
          </Link>
          <Link to="/universities">
            <Button variant="outline" className="rounded-full h-11 px-6 font-semibold">
              <ArrowLeft className="w-4 h-4 mr-2" /> Explore Universities
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
